<div class="col-xs-12 bdr-2-black p-2 mt-4">
  <div class="col-xs-12 flex items-center">
    <span class="m-0" style="font-weight: 600;">Extra Images With Tags</span>
    <span class="m-l-xs m-r-xs" role="button" tabindex="0"
      style="cursor: pointer;"
      (click)="addRow()"
      (keydown.enter)="addRow()"
      (keydown.space)="$event.preventDefault(); addRow()"
      aria-label="Add row">
      <i class="fa fa-plus-square-o"></i>
    </span>
  </div>
  <p class="col-xs-12 text-muted" style="font-size: 12px;">
    Upload images with tags and priority for feature-level display across the app.
    Title and Content take a <b>language string id</b>, not plain text — create the string in the
    <a [href]="newLanguageStringUrl()" target="_blank">LanguageString table</a> first, then paste its id here.
  </p>

  <div *ngFor="let row of rows; let i = index;" class="col-xs-12 mb-3 image-with-tag-row" [class.has-error]="!!row.error">
    <div class="col-xs-12 flex items-start">
      <div class="col-xs-3">
        <div *ngIf="row.imageLink" class="mb-1">
          <img [src]="row.imageLink" width="80" height="80" alt="tagged_img"
            style="object-fit: cover; border: 1px solid #ddd; border-radius: 4px;"/>
        </div>
        <input type="file" accept="image/*" [disabled]="row.uploading"
          (change)="uploadImage($event.target.files, row)"
          [name]="'extraImageWithTag_file_' + i"/>
        <div *ngIf="row.uploading" class="text-muted mt-1" style="font-size: 12px;">Uploading…</div>
      </div>

      <div class="col-xs-3 pl-3">
        <label class="mb-1" style="font-size: 12px;" [attr.for]="'extraImageWithTag_tag_' + i">Tag</label>
        <input type="text" class="form-control" placeholder="Tag"
          [(ngModel)]="row.tag"
          [id]="'extraImageWithTag_tag_' + i"
          [name]="'extraImageWithTag_tag_' + i"/>
      </div>

      <div class="col-xs-2 pl-3">
        <label class="mb-1" style="font-size: 12px;" [attr.for]="'extraImageWithTag_priority_' + i">Priority</label>
        <input type="number" [(ngModel)]="row.priority"
          [id]="'extraImageWithTag_priority_' + i"
          [name]="'extraImageWithTag_priority_' + i" class="form-control" min="1" required/>
      </div>

      <div class="col-xs-1 pl-3" style="padding-top: 20px;">
        <span role="button" tabindex="0"
          style="cursor: pointer;"
          (click)="removeRow(i)"
          (keydown.enter)="removeRow(i)"
          (keydown.space)="$event.preventDefault(); removeRow(i)"
          aria-label="Remove row">
          <i class="fa fa-trash-o" style="font-size: 18px; color: #d9534f;"></i>
        </span>
      </div>
    </div>

    <div class="col-xs-12 flex items-start mt-2">
      <div class="col-xs-4">
        <label class="mb-1" style="font-size: 12px;" [attr.for]="'extraImageWithTag_title_' + i">
          Title Language String Id <span class="text-muted">(optional)</span>
        </label>
        <input type="text" class="form-control" placeholder="Language string id"
          [(ngModel)]="row.titleLanguageStringId"
          (blur)="loadLanguageStringTexts(row)"
          [id]="'extraImageWithTag_title_' + i"
          [name]="'extraImageWithTag_title_' + i"/>
        <div *ngIf="row.titleLanguageStringText" class="text-muted mt-1" style="font-size: 12px;">
          {{ row.titleLanguageStringText }}
          <a [href]="languageStringEditUrl(row.titleLanguageStringId)" target="_blank" class="ml-1">edit</a>
        </div>
      </div>
      <div class="col-xs-4 pl-3">
        <label class="mb-1" style="font-size: 12px;" [attr.for]="'extraImageWithTag_content_' + i">
          Content Language String Id <span class="text-muted">(optional)</span>
        </label>
        <input type="text" class="form-control" placeholder="Language string id"
          [(ngModel)]="row.contentLanguageStringId"
          (blur)="loadLanguageStringTexts(row)"
          [id]="'extraImageWithTag_content_' + i"
          [name]="'extraImageWithTag_content_' + i"/>
        <div *ngIf="row.contentLanguageStringText" class="text-muted mt-1" style="font-size: 12px;">
          {{ row.contentLanguageStringText }}
          <a [href]="languageStringEditUrl(row.contentLanguageStringId)" target="_blank" class="ml-1">edit</a>
        </div>
      </div>
    </div>

    <div *ngIf="row.error" class="col-xs-12 text-danger mt-1" style="font-size: 12px;">
      <i class="fa fa-exclamation-circle"></i> {{ row.error }}
    </div>
  </div>
</div>
